import React from 'react';
import { Link } from 'react-router-dom';
import { getToUrl } from 'utils/translation';
import HealthFirstAnswer from './Answers/PersonalHealth/FirstAnswer';
import HealthSecondAnswer from './Answers/PersonalHealth/SecondAnswer';
import WaterQualityFirstAnswer from './Answers/WaterQuality/FirstAnswer';
import WaterQualitySecondAnswer from './Answers/WaterQuality/SecondAnswer';
import FactorsFirstAnswer from './Answers/EnvironmentFactors/FirstAnswer';
import FactorsSecondAnswer from './Answers/EnvironmentFactors/SecondAnswer';
import EquipmentFirstAnswer from './Answers/EquipmentMaintenance/FirstAnswer';
import EquipmentSecondAnswer from './Answers/EquipmentMaintenance/SecondAnswer';

export const quizQuestions = {
  'Personal Health': [
    {
      text:
        'Are you concerned about contaminated water or what you and your family may be exposed to??',
      answers: {
        YES: {
          view: <HealthFirstAnswer />,
          main: 'Good, you should be... ',
          text:
            'Water travels a long way before reaching your home, and a lot can happen along the way.',
        },
        NO: {
          view: <HealthFirstAnswer />,
          main: 'Maybe you should be... ',
          text:
            'Water travels a long way before reaching your home, and a lot can happen along the way.',
        },
      },
    },
    {
      text: 'Are you drinking the recommended amount of water per day?',
      answers: {
        YES: {
          view: <HealthSecondAnswer />,
          main: "Good, you're probably enjoying all of these health benefits: ",
          text:
            'Improved overall health, better nutrient/vitamin absorption rates, general weight loss,  skin hydration, and detoxification.',
        },
        NO: {
          view: <HealthSecondAnswer />,
          main:
            "Well, you probably should. It's proven that pure healthy water will enhance: ",
          text:
            'Improved overall health, better nutrient/vitamin absorption rates, general weight loss,  skin hydration, and detoxification.',
        },
      },
    },
  ],
  'Water Quality': [
    {
      text: 'Do you enjoy pure, clean, fresh-tasting water?',
      answers: {
        YES: {
          view: <WaterQualityFirstAnswer />,
          main: "Good, that's what we're all about.",
          text:
            'PureFlo® drinking water filtration systems filter out impurities that many people are unaware of.',
        },
        NO: {
          view: <WaterQualityFirstAnswer />,
          main: 'Maybe you should be?',
          text:
            'PureFlo® drinking water filtration systems filter out impurities that many people are unaware of.',
        },
      },
    },
    {
      text: 'Do you know you need or want filtration for your home or office?',
      answers: {
        YES: {
          view: <WaterQualitySecondAnswer />,
          main: "Good, you're on the right path:",
          text:
            "Sometimes it's whats behind the scenes that makes all the difference.",
        },
        NO: {
          view: <WaterQualitySecondAnswer />,
          main: 'Maybe you should be?',
          text:
            "Sometimes it's whats behind the scenes that makes all the difference.",
        },
      },
    },
  ],
  'Environmental Impact': [
    {
      text: 'Are you concerned about the environment?',
      answers: {
        YES: {
          view: <FactorsFirstAnswer />,
          main: 'Good. So are we.',
          text:
            "That's one of the reasons why we offer Smart Monitoring with each of our products. You'll never have to change a filter until it's really time, which means less waste and more cost savings.",
        },
        NO: {
          view: <FactorsFirstAnswer />,
          main: 'We are. Maybe you could be?',
          text:
            "We know it's not top of mind for everyone, so we equip every unit we sell with Smart Monitoring, so you'll never have to change a filter until it's really time, which means less waste and more cost savings.",
        },
      },
    },
    {
      text: 'Is your location prone to hard water?',
      answers: {
        YES: {
          view: <FactorsSecondAnswer />,
          main:
            'Then you know that filtering your water can help with that issue.',
          text: 'Surprisingly, much of the coutry has hard water too.',
        },
        NO: {
          view: <FactorsSecondAnswer />,
          main: 'You could.',
          text: "You'd be surprised how much of the country has hard water.",
        },
      },
    },
  ],
  'Equipment Maintenance': [
    {
      text:
        'Do you notice a build up of residue, rust, or sediment on your sinks, faucets, or appliances?',
      answers: {
        YES: {
          view: <EquipmentFirstAnswer />,
          main: 'We can help.',
          text: (
            <div>
              Our advanced technology can help reduce or eliminate those issues.{' '}
              <Link to={getToUrl('/why-us', 'U19')}>Learn more.</Link>
            </div>
          ),
        },
        NO: {
          view: <EquipmentFirstAnswer />,
          main: "Maybe your water doesn't taste or smell refreshing?",
          text: (
            <div>
              There are many contaminants you can&apos;t see and our advanced
              technology can help reduce or eliminate those issues.{' '}
              <Link to={getToUrl('/why-us', 'U20')}>Learn more.</Link>
            </div>
          ),
        },
      },
    },
    {
      text:
        'Do you prefer the convenience of smart and innovative technology to monitor and alert you when maintenance is required?',
      answers: {
        YES: {
          view: <EquipmentSecondAnswer />,
          main: 'Great!',
          text:
            'Each of our technologically advanced units is equipped to do just that.',
        },
        NO: {
          view: <EquipmentSecondAnswer />,
          main: 'Maybe you should be?',
          text:
            'Having constant IoT monitoring can make having clean, renewable water on-hand much simpler.',
        },
      },
    },
  ],
};
